import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AssignmentFiltersBar from "../../components/Tutor/AssignmentFiltersBar";
import TutorAssignmentCardRow from "../../components/Tutor/TutorAssignmentCardRow";
import ShareAssignmentModal from "../../components/Tutor/ShareAssignmentModal";
import useTutorPackets from "../../hooks/useTutorPackets";

/* ---------- TEMP DATA ---------- */

const dummyAssignments = [
  {
    id: "math-geo-1",
    category: "Math",
    title: "Geometry",
    subtitle: "Intermediate #4",
    problemCount: 67,
    assignedCount: 4,
    starred: true,
    testType: "SAT",
    section: "Math",
    subSection: "Geometry",
  },
  {
    id: "reading-deduction-2",
    category: "Reading",
    title: "Deduction",
    subtitle: "Core Skills #2",
    problemCount: 42,
    assignedCount: 2,
    starred: false,
    testType: "SAT",
    section: "Reading",
    subSection: "Deduction",
  },
  {
    id: "english-grammar-1",
    category: "English",
    title: "Grammar",
    subtitle: "Foundations #1",
    problemCount: 55,
    assignedCount: 6,
    starred: false,
    testType: "ACT",
    section: "English",
    subSection: "Grammar",
  },
];

/* ---------- PAGE ---------- */

const TutorAssignments = () => {
  const navigate = useNavigate();
  const { packets, setPackets, loading } = useTutorPackets();

  const [filters, setFilters] = useState({
    testType: "ALL",
    section: "ALL",
    subSection: "ALL",
    starredOnly: false,
  });
  const [shareOpen, setShareOpen] = useState(false);
  const [activeAssignment, setActiveAssignment] = useState(null);

  const filteredAssignments = packets.filter((a) => {
    if (filters.testType !== "ALL" && a.testType !== filters.testType)
      return false;
    if (filters.section !== "ALL" && a.section !== filters.section)
      return false;
    if (
      filters.subSection !== "ALL" &&
      a.subSection !== filters.subSection
    )
      return false;
    if (filters.starredOnly && !a.starred) return false;
    return true;
  });

  if (loading) {
    return (
      <Typography variant="body1">
        Loading assignments…
      </Typography>
    );
  }

  return (
    <Box>
      <Typography variant="h4" fontWeight={600} mb={2}>
        Assignments
      </Typography>

      <AssignmentFiltersBar
        filters={filters}
        setFilters={setFilters}
      />

      <TutorAssignmentCardRow
        assignments={filteredAssignments}
        onView={(a) =>
          navigate(`/tutor/assignments/${a.id}/question`, {
            state: {
              assignment: a,
              sourceType: a.type,
            },
          })
        }
        onShare={(a) => {
          setActiveAssignment(a);
          setShareOpen(true);
        }}
      />

      <ShareAssignmentModal
        open={shareOpen}
        onClose={() => {
          setShareOpen(false);
          setActiveAssignment(null);
        }}
        assignment={activeAssignment}
        onAssigned={(packetId, count) => {
          setPackets((prev) =>
            prev.map((p) =>
              p.id === packetId
                ? { ...p, assignedCount: p.assignedCount + count }
                : p
            )
          );
        }}
      />
    </Box>
  );
};

export default TutorAssignments;
